import type { openMindedCirclesSection } from '../../../../app/_shared/marketing/landingContent';
import { OpenMindedPillarIcon } from './OpenMindedPillarIcon';
import { OpenMindedVisual } from './OpenMindedVisual';
import './landingRef.css';

type Props = {
  h2: string;
  lead: string;
  paragraphs: readonly string[];
  pillars: typeof openMindedCirclesSection.pillars;
};

export function OpenMindedCirclesSection({ h2, lead, paragraphs, pillars }: Props) {
  return (
    <section className="open-minded-section" aria-labelledby="open-minded-heading">
      <div className="open-minded-section__layout">
        <div className="open-minded-section__copy">
          <h2 id="open-minded-heading" className="ml-heading-serif ml-text-heading">
            {h2}
          </h2>
          <p className="open-minded-section__lead">{lead}</p>
          {paragraphs.map((para) => (
            <p key={para} className="open-minded-section__body">
              {para}
            </p>
          ))}
          <ul className="open-minded-section__pillars" aria-label="How Open-minded Circles work">
            {pillars.map((pillar) => (
              <li key={pillar.label}>
                <span className="open-minded-section__pillarIcon" aria-hidden>
                  <OpenMindedPillarIcon kind={pillar.glyph} />
                </span>
                <span>{pillar.label}</span>
              </li>
            ))}
          </ul>
        </div>
        <OpenMindedVisual />
      </div>
    </section>
  );
}
